// ==== STATISTICS + HOME ====
// Split from the original single tempdashboard.js (originally lines 5852-6752).
// Loaded as a plain classic <script defer> alongside the other tempdashboard-*.js files --
// they all share one global scope (like separate parts of one big file), so functions and
// top-level let/const declared in any of these files are visible to all the others, as long
// as the <script> tags stay in the same order every one of these files was split in.

  // ---- STATISTICS: read-only analytics, computed fresh each time the tab
  // opens (not live-subscribed -- same on-tab-switch pattern already used
  // for this page) from data already loaded elsewhere: pigeons, trainings,
  // feedings, feedTypes, breedingPairs, registry, trackerGroups,
  // joinedFlights. No Add/Edit/Delete on this page by design (read-only
  // overview). Three metrics have no real, cheaply-computable data source
  // anywhere in this app yet -- org-wide GPS-tracked distance (trackers and
  // groups both), tracker uptime%, and breeding-pair nesting/weaning stage
  // -- those show "—" instead of a fabricated number; flagged again in the
  // delivery message. Full rebuild 2026-09-22 matching the new mockup.
  let statsRangeFrom = '';
  let statsRangeTo = '';
  let statsSeasonFilter = 'all';

  function statsMonthStartMs() { const d = new Date(); d.setDate(1); d.setHours(0, 0, 0, 0); return d.getTime(); }
  function statsPrevMonthRangeMs() {
    const now = new Date();
    return [new Date(now.getFullYear(), now.getMonth() - 1, 1).getTime(), statsMonthStartMs()];
  }
  function statsCreatedAtMs(doc) { return doc && doc.createdAt && doc.createdAt.toMillis ? doc.createdAt.toMillis() : null; }
  function statsAxisDate(ms) {
    const d = new Date(ms);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return d.getDate() + ' ' + months[d.getMonth()];
  }
  function setStatsSub(id, text) {
    const el = document.getElementById(id);
    if (!el) return;
    el.innerHTML = text ? '<i class="fa-solid fa-arrow-up"></i> ' + text : '';
  }

  function populateStatsSeasonFilter() {
    const sel = document.getElementById('stats-season-filter');
    if (!sel) return;
    const current = sel.value;
    const ids = Object.keys(seasons).sort((a, b) => (seasons[b].year || 0) - (seasons[a].year || 0));
    sel.innerHTML = '<option value="all">All Seasons</option>' + ids.map(id => `<option value="${id}">${seasons[id].name} (${seasons[id].year})</option>`).join('');
    sel.value = ids.includes(current) ? current : (statsSeasonFilter === 'all' || ids.includes(statsSeasonFilter) ? statsSeasonFilter : 'all');
  }
  function statsUpdateRangeLabel() {
    const label = document.getElementById('stats-range-label');
    if (!label) return;
    label.textContent = (statsRangeFrom && statsRangeTo) ? (fmtDateOnly(new Date(statsRangeFrom).getTime()) + ' - ' + fmtDateOnly(new Date(statsRangeTo).getTime())) : 'Select Date Range';
  }

  function renderStatsDonut(rows, total, centerNum, centerLabel) {
    const size = 160, cx = size / 2, cy = size / 2, r = 58, strokeW = 22;
    const circumference = 2 * Math.PI * r;
    let offset = 0;
    const segs = rows.map(row => {
      const frac = total ? row.value / total : 0;
      const len = frac * circumference;
      const seg = `<circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="${row.color}" stroke-width="${strokeW}" stroke-dasharray="${len.toFixed(1)} ${(circumference - len).toFixed(1)}" stroke-dashoffset="${(-offset).toFixed(1)}" transform="rotate(-90 ${cx} ${cy})"></circle>`;
      offset += len;
      return seg;
    }).join('');
    const svg = `<svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
      <circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="var(--bg-page)" stroke-width="${strokeW}"></circle>
      ${segs}
      <text x="${cx}" y="${cy - 4}" text-anchor="middle" font-size="20" font-weight="800" fill="var(--text-main)">${centerNum}</text>
      <text x="${cx}" y="${cy + 14}" text-anchor="middle" font-size="11" fill="var(--text-secondary)">${centerLabel}</text>
    </svg>`;
    const legend = '<div class="stats-donut-legend">' + rows.map(row => {
      const pct = total ? Math.round((row.value / total) * 100) : 0;
      return `<div class="stats-donut-legend-row"><span class="stats-donut-dot" style="background:${row.color};"></span><span class="stats-donut-legend-name">${row.label}</span><span class="stats-donut-legend-pct">${pct}%</span></div>`;
    }).join('') + '</div>';
    return svg + legend;
  }

  function renderStatsSummaryCards(myPigeons, trainingIds) {
    const mStart = statsMonthStartMs();
    const allTrainingIds = Object.keys(trainings);

    const pigeonsThisMonth = myPigeons.filter(d => { const ms = statsCreatedAtMs(d.p); return ms != null && ms >= mStart; }).length;
    document.getElementById('stats-c-pigeons').textContent = myPigeons.length;
    setStatsSub('stats-c-pigeons-sub', pigeonsThisMonth ? '+' + pigeonsThisMonth + ' this month' : null);

    const trainingsThisMonth = allTrainingIds.filter(id => (trainings[id].releaseAtMs || 0) >= mStart).length;
    document.getElementById('stats-c-trainings').textContent = trainingIds.length;
    setStatsSub('stats-c-trainings-sub', trainingsThisMonth ? '+' + trainingsThisMonth + ' this month' : null);

    const totalDistance = trainingIds.reduce((s, id) => s + (trainings[id].distanceKm || 0), 0);
    const distanceThisMonth = allTrainingIds.filter(id => (trainings[id].releaseAtMs || 0) >= mStart).reduce((s, id) => s + (trainings[id].distanceKm || 0), 0);
    document.getElementById('stats-c-distance').textContent = Math.round(totalDistance) + ' km';
    setStatsSub('stats-c-distance-sub', distanceThisMonth ? '+' + Math.round(distanceThisMonth) + ' km this month' : null);

    const pctList = trainingIds.map(id => trainingReturnPct(trainings[id])).filter(p => p !== null);
    const avgReturn = pctList.length ? Math.round(pctList.reduce((a, b) => a + b, 0) / pctList.length) : 0;
    document.getElementById('stats-c-return').textContent = avgReturn + '%';

    const allFeedIds = Object.keys(feedings);
    const feedingsThisMonth = allFeedIds.filter(id => (feedings[id].fedAtMs || 0) >= mStart).length;
    document.getElementById('stats-c-feeding').textContent = allFeedIds.length;
    setStatsSub('stats-c-feeding-sub', feedingsThisMonth ? '+' + feedingsThisMonth + ' this month' : null);

    const pairIds = Object.keys(breedingPairs);
    const pairsThisMonth = pairIds.filter(id => { const ms = statsCreatedAtMs(breedingPairs[id]); return ms != null && ms >= mStart; }).length;
    document.getElementById('stats-c-pairs').textContent = pairIds.length;
    setStatsSub('stats-c-pairs-sub', pairsThisMonth ? '+' + pairsThisMonth + ' this month' : null);

    const trackerIds = Object.keys(registry).filter(id => isAdmin || myTrackerMemberships[id]);
    document.getElementById('stats-c-trackers').textContent = trackerIds.length;
    setStatsSub('stats-c-trackers-sub', null);

    const groupCount = Object.keys(trackerGroups).length + Object.keys(joinedFlights).length;
    document.getElementById('stats-c-groups').textContent = groupCount;
    setStatsSub('stats-c-groups-sub', null);
  }

  function renderStatsTrainingPerformance(trainingIds) {
    const wrap = document.getElementById('stats-perf-chart');
    const emptyEl = document.getElementById('stats-perf-empty');
    if (!wrap) return;
    const sorted = trainingIds.slice().sort((a, b) => (trainings[a].releaseAtMs || 0) - (trainings[b].releaseAtMs || 0));
    const list = sorted.slice(-8);
    if (!list.length) { wrap.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';

    const W = 620, H = 220, padL = 8, padR = 8, padT = 16, padB = 26;
    const plotW = W - padL - padR, plotH = H - padT - padB;
    const maxDist = Math.max(10, ...list.map(id => trainings[id].distanceKm || 0));
    const n = list.length;
    const step = plotW / n;
    const barW = Math.min(30, step * 0.5);

    const bars = list.map((id, i) => {
      const d = trainings[id].distanceKm || 0;
      const h = maxDist ? (d / maxDist) * plotH : 0;
      const x = padL + step * i + (step - barW) / 2;
      const y = padT + plotH - h;
      return `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${barW.toFixed(1)}" height="${h.toFixed(1)}" rx="3" fill="#2f6fed"></rect>`;
    }).join('');

    const points = list.map((id, i) => {
      const pct = trainingReturnPct(trainings[id]);
      const p = pct === null ? 0 : pct;
      return { x: padL + step * i + step / 2, y: padT + plotH - (p / 100) * plotH };
    });
    const linePath = points.map((p, i) => (i === 0 ? 'M' : 'L') + p.x.toFixed(1) + ' ' + p.y.toFixed(1)).join(' ');
    const dots = points.map(p => `<circle cx="${p.x.toFixed(1)}" cy="${p.y.toFixed(1)}" r="3.5" fill="#19a974"></circle>`).join('');
    const labels = list.map((id, i) => `<text x="${(padL + step * i + step / 2).toFixed(1)}" y="${H - 8}" font-size="10.5" fill="var(--text-secondary)" text-anchor="middle">${statsAxisDate(trainings[id].releaseAtMs)}</text>`).join('');
    let grid = '';
    for (let g = 0; g <= 4; g++) {
      const y = padT + plotH - (g / 4) * plotH;
      grid += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${W - padR}" y2="${y.toFixed(1)}" stroke="var(--border)" stroke-width="1"></line>`;
    }
    wrap.innerHTML = `<svg viewBox="0 0 ${W} ${H}" width="100%" style="max-width:${W}px;">${grid}${bars}<path d="${linePath}" fill="none" stroke="#19a974" stroke-width="2"></path>${dots}${labels}</svg>` +
      '<div class="stats-chart-legend"><span><i style="background:#2f6fed;"></i>Distance (km)</span><span><i class="stats-legend-line" style="background:#19a974;"></i>Return Rate (%)</span></div>';
  }

  function renderStatsFeedingUsage() {
    const wrap = document.getElementById('stats-feedusage-chart');
    const emptyEl = document.getElementById('stats-feedusage-empty');
    if (!wrap) return;
    const cutoff = Date.now() - 30 * 86400000;
    const totals = {};
    let grand = 0;
    Object.values(feedings).forEach(f => {
      if (f.status === 'scheduled' || !f.fedAtMs || f.fedAtMs > Date.now() || f.fedAtMs < cutoff || !f.feedTypeId || !(f.quantity > 0)) return;
      totals[f.feedTypeId] = (totals[f.feedTypeId] || 0) + f.quantity;
      grand += f.quantity;
    });
    const rows = Object.keys(totals).map(id => ({ id, qty: totals[id] })).sort((a, b) => b.qty - a.qty).slice(0, 6);
    if (!rows.length) { wrap.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    wrap.innerHTML = renderStatsDonut(rows.map(r => ({
      label: (feedTypes[r.id] && feedTypes[r.id].name) || 'Unknown',
      value: r.qty,
      color: (feedTypes[r.id] && feedTypes[r.id].colorHex) || '#8a97a3'
    })), grand, Math.round(grand), 'kg Total');
  }

  function renderStatsPigeonStatus(myPigeons) {
    const wrap = document.getElementById('stats-pigeonstatus-chart');
    const emptyEl = document.getElementById('stats-pigeonstatus-empty');
    if (!wrap) return;
    if (!myPigeons.length) { wrap.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';

    const activeSeasonId = Object.keys(seasons).find(id => seasons[id].isActive) || null;
    const breedingPigeonIds = new Set();
    Object.values(breedingPairs).forEach(pair => {
      if (activeSeasonId && pair.seasonId !== activeSeasonId) return;
      if (pair.cockId) breedingPigeonIds.add(pair.cockId);
      if (pair.henId) breedingPigeonIds.add(pair.henId);
    });
    const recentTrainingCutoff = Date.now() - 14 * 86400000;
    const trainingPigeonIds = new Set();
    Object.values(trainings).forEach(t => {
      if (trainingStatusOf(t) === 'completed' && (t.releaseAtMs || 0) < recentTrainingCutoff) return;
      (t.participatingPigeonIds || []).forEach(id => trainingPigeonIds.add(id));
    });

    let active = 0, inTraining = 0, breeding = 0, inactive = 0;
    myPigeons.forEach(d => {
      if (d.p.isArchived) { inactive++; return; }
      if (breedingPigeonIds.has(d.id)) { breeding++; return; }
      if (trainingPigeonIds.has(d.id)) { inTraining++; return; }
      active++;
    });
    const total = myPigeons.length;
    const rows = [
      { label: 'Active', value: active, color: '#19a974' },
      { label: 'In Training', value: inTraining, color: '#e5537e' },
      { label: 'Breeding', value: breeding, color: '#f4a623' },
      { label: 'Inactive', value: inactive, color: '#8a97a3' }
    ].filter(r => r.value > 0);
    wrap.innerHTML = renderStatsDonut(rows, total, total, 'Total');
  }

  function renderStatsBreedingOverview() {
    const pairIds = Object.keys(breedingPairs);
    document.getElementById('stats-breed-pairs').textContent = pairIds.length;
    const totalOffspring = pairIds.reduce((sum, id) => sum + pairOffspring(breedingPairs[id]).length, 0);
    document.getElementById('stats-breed-hatched').textContent = totalOffspring;
    // Currently Nesting / Weaned: breeding pairs have no nesting-stage field
    // at all yet -- "—" rather than a fabricated number.
  }

  function renderStatsTopPerforming(myPigeons) {
    const tbody = document.getElementById('stats-topperf-body');
    const emptyEl = document.getElementById('stats-topperf-empty');
    if (!tbody) return;
    const perPigeon = {};
    Object.values(trainings).forEach(t => {
      if (trainingStatusOf(t) !== 'completed') return;
      const distance = t.distanceKm || 0;
      (t.participatingPigeonIds || []).forEach(pid => {
        if (!perPigeon[pid]) perPigeon[pid] = { participated: 0, arrived: 0, distance: 0 };
        perPigeon[pid].participated++;
        perPigeon[pid].distance += distance;
        if (t.arrivals && t.arrivals[pid]) perPigeon[pid].arrived++;
      });
    });
    const rows = myPigeons.map(d => {
      const s = perPigeon[d.id];
      if (!s || !s.participated) return null;
      return { p: d.p, pct: Math.round((s.arrived / s.participated) * 100), distance: s.distance };
    }).filter(Boolean).sort((a, b) => b.pct - a.pct || b.distance - a.distance).slice(0, 5);

    if (!rows.length) { tbody.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    tbody.innerHTML = rows.map((r, i) => `
      <tr>
        <td><span class="stats-mini-rank">${i + 1}</span></td>
        <td><div class="stats-mini-avatar">${pigeonAvatarHtml(r.p)}<b>${r.p.name}</b></div></td>
        <td>${r.pct}%</td>
        <td>${Math.round(r.distance)} km</td>
      </tr>`).join('');
  }

  function renderStatsRecentTrainings() {
    const tbody = document.getElementById('stats-recent-body');
    const emptyEl = document.getElementById('stats-recent-empty');
    if (!tbody) return;
    const ids = Object.keys(trainings).sort((a, b) => (trainings[b].releaseAtMs || 0) - (trainings[a].releaseAtMs || 0)).slice(0, 5);
    if (!ids.length) { tbody.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    tbody.innerHTML = ids.map(id => {
      const t = trainings[id];
      const pct = trainingReturnPct(t);
      return `<tr>
        <td>${t.releaseAtMs ? fmtDateOnly(t.releaseAtMs) : '—'}</td>
        <td>${trainingNameOf(t)}</td>
        <td>${t.distanceKm || 0} km</td>
        <td>${pct !== null ? pct + '%' : '—'}</td>
      </tr>`;
    }).join('');
  }

  function renderStatsTrackerStats() {
    const trackerIds = isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships);
    document.getElementById('stats-trk-active').textContent = trackerIds.length;
    // Total Tracked Distance / Uptime: no org-wide GPS-distance or uptime
    // aggregate exists anywhere in this app -- "—" rather than a fabricated
    // number (per-tracker path length is only ever computed live, one
    // tracker at a time, in New Track's own detail view).
    const tbody = document.getElementById('stats-trk-body');
    const emptyEl = document.getElementById('stats-trk-empty');
    if (!tbody) return;
    const rows = trackerIds.slice(0, 5).map(rawId => {
      const regData = registry[rawId] || {};
      const assignedPigeon = allPigeonDocs.find(d => d.id === regData.assignedPigeonId);
      const battery = typeof regData.lastVernalBattery === 'number' ? regData.lastVernalBattery : null;
      const seenMs = regData.lastVernalTimestamp || null;
      // trackerStatusOf() (defined in the Trackers page's own code, later
      // in load order) is the single source of truth for this -- safe to
      // call from here since it's only ever invoked once the tab is
      // actually opened, long after every tempdashboard-*.js file has
      // loaded, same reasoning as every other cross-file call in this app.
      const statusInfo = trackerStatusOf(regData);
      const statusClass = statusInfo.cls, statusLabel = statusInfo.label;
      return {
        name: assignedPigeon ? assignedPigeon.p.name : (regData.nickname || rawId),
        seen: seenMs ? timeAgo(seenMs) : '—',
        battery: battery != null ? battery + '%' : '—',
        statusClass, statusLabel
      };
    });
    if (!rows.length) { tbody.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    tbody.innerHTML = rows.map(r => `<tr>
      <td>${r.name}</td><td>${r.seen}</td><td>${r.battery}</td>
      <td><span class="stats-mini-status stats-mini-status--${r.statusClass}">${r.statusLabel}</span></td>
    </tr>`).join('');
  }

  function renderStatsGroupSummary() {
    const ownedIds = Object.keys(trackerGroups);
    const joinedIds = Object.keys(joinedFlights);
    const allGroups = ownedIds.map(id => ({ id, g: trackerGroups[id] })).concat(joinedIds.map(id => ({ id, g: joinedFlights[id] })));

    const activeCount = allGroups.filter(({ g }) => {
      if (g.endTime) return false;
      const startMs = g.startTime && g.startTime.toMillis ? g.startTime.toMillis() : null;
      return !(startMs && startMs > Date.now());
    }).length;
    document.getElementById('stats-grp-active').textContent = activeCount;

    const pigeonSet = new Set();
    allGroups.forEach(({ g }) => (g.trackerIds || []).forEach(rawId => {
      const assigned = (registry[rawId] || {}).assignedPigeonId;
      if (assigned) pigeonSet.add(assigned);
    }));
    document.getElementById('stats-grp-pigeons').textContent = pigeonSet.size;
    // Total Group Distance: same "no cheap GPS-distance aggregate" gap as
    // Tracker Statistics above -- "—" per group and for the total.

    const tbody = document.getElementById('stats-grp-body');
    const emptyEl = document.getElementById('stats-grp-empty');
    if (!tbody) return;
    const rows = allGroups
      .sort((a, b) => {
        const ta = a.g.createdAt && a.g.createdAt.toMillis ? a.g.createdAt.toMillis() : 0;
        const tb = b.g.createdAt && b.g.createdAt.toMillis ? b.g.createdAt.toMillis() : 0;
        return tb - ta;
      })
      .slice(0, 5)
      .map(({ g }) => {
        const startMs = g.startTime && g.startTime.toMillis ? g.startTime.toMillis() : null;
        return { name: g.name || 'Untitled', count: (g.trackerIds || []).length, last: startMs ? timeAgo(startMs) : '—' };
      });
    if (!rows.length) { tbody.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    tbody.innerHTML = rows.map(r => `<tr><td>${r.name}</td><td>${r.count}</td><td>—</td><td>${r.last}</td></tr>`).join('');
  }

  function renderStatsDistanceSummary(activeSeasonId) {
    const mStart = statsMonthStartMs();
    const allTrainingsArr = Object.values(trainings);
    const monthKm = allTrainingsArr.filter(t => (t.releaseAtMs || 0) >= mStart).reduce((s, t) => s + (t.distanceKm || 0), 0);
    const seasonKm = activeSeasonId ? allTrainingsArr.filter(t => t.seasonId === activeSeasonId).reduce((s, t) => s + (t.distanceKm || 0), 0) : 0;
    const allTimeKm = allTrainingsArr.reduce((s, t) => s + (t.distanceKm || 0), 0);
    document.getElementById('stats-dist-month').textContent = Math.round(monthKm) + ' km';
    document.getElementById('stats-dist-season').textContent = Math.round(seasonKm) + ' km';
    document.getElementById('stats-dist-alltime').textContent = Math.round(allTimeKm) + ' km';
  }

  function renderStatsQuickInsights(myPigeons) {
    const list = document.getElementById('stats-insights-list');
    const emptyEl = document.getElementById('stats-insights-empty');
    if (!list) return;
    const insights = [];
    const mStart = statsMonthStartMs();
    const [pmStart, pmEnd] = statsPrevMonthRangeMs();

    const pctFor = (fromMs, toMs) => {
      const ids = Object.keys(trainings).filter(id => { const ms = trainings[id].releaseAtMs || 0; return ms >= fromMs && ms < toMs; });
      const pcts = ids.map(id => trainingReturnPct(trainings[id])).filter(p => p !== null);
      return pcts.length ? pcts.reduce((a, b) => a + b, 0) / pcts.length : null;
    };
    const thisMonthPct = pctFor(mStart, Date.now() + 1);
    const lastMonthPct = pctFor(pmStart, pmEnd);
    if (thisMonthPct !== null && lastMonthPct !== null) {
      const diff = Math.round(thisMonthPct - lastMonthPct);
      if (diff > 0) insights.push(`Return rate improved by ${diff}% this month.`);
      else if (diff < 0) insights.push(`Return rate dropped by ${Math.abs(diff)}% this month.`);
      else insights.push(`Return rate held steady at ${Math.round(thisMonthPct)}% this month.`);
    }

    const cutoff = Date.now() - 30 * 86400000;
    const feedTotals = {};
    Object.values(feedings).forEach(f => {
      if (f.status === 'scheduled' || !f.fedAtMs || f.fedAtMs > Date.now() || f.fedAtMs < cutoff || !f.feedTypeId) return;
      feedTotals[f.feedTypeId] = (feedTotals[f.feedTypeId] || 0) + (f.quantity || 0);
    });
    const topFeedId = Object.keys(feedTotals).sort((a, b) => feedTotals[b] - feedTotals[a])[0];
    if (topFeedId && feedTypes[topFeedId]) {
      const grand = Object.values(feedTotals).reduce((a, b) => a + b, 0);
      const pct = grand ? Math.round((feedTotals[topFeedId] / grand) * 100) : 0;
      insights.push(`${feedTypes[topFeedId].name} is the most used feed (${pct}%).`);
    }

    const perPigeon = {};
    Object.values(trainings).forEach(t => {
      if (trainingStatusOf(t) !== 'completed') return;
      (t.participatingPigeonIds || []).forEach(pid => {
        if (!perPigeon[pid]) perPigeon[pid] = { participated: 0, arrived: 0 };
        perPigeon[pid].participated++;
        if (t.arrivals && t.arrivals[pid]) perPigeon[pid].arrived++;
      });
    });
    const best = myPigeons.map(d => { const s = perPigeon[d.id]; return s && s.participated ? { name: d.p.name, pct: Math.round((s.arrived / s.participated) * 100) } : null; })
      .filter(Boolean).sort((a, b) => b.pct - a.pct)[0];
    if (best) insights.push(`${best.name} has the best performance (${best.pct}% return rate).`);

    const trackerIds = isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships);
    if (trackerIds.length) {
      const recent = trackerIds.filter(id => registry[id] && registry[id].lastVernalTimestamp && (Date.now() - registry[id].lastVernalTimestamp) < 48 * 3600000).length;
      insights.push(`${recent} of ${trackerIds.length} tracker${trackerIds.length === 1 ? '' : 's'} reporting in the last 48 hours.`);
    }

    const activeGroupNames = [];
    Object.keys(trackerGroups).forEach(id => {
      const g = trackerGroups[id];
      if (g.endTime) return;
      const startMs = g.startTime && g.startTime.toMillis ? g.startTime.toMillis() : null;
      if (startMs && startMs > Date.now()) return;
      activeGroupNames.push(g.name || 'Untitled');
    });
    if (activeGroupNames.length) insights.push(`Group "${activeGroupNames[0]}" is currently in progress.` + (activeGroupNames.length > 1 ? ` (+${activeGroupNames.length - 1} more)` : ''));

    const feedingsThisMonth = Object.values(feedings).filter(f => (f.fedAtMs || 0) >= mStart).length;
    if (feedingsThisMonth) insights.push(`${feedingsThisMonth} new feeding record${feedingsThisMonth === 1 ? '' : 's'} added this month.`);

    if (!insights.length) { list.innerHTML = ''; emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    list.innerHTML = insights.map(text => `<li><i class="fa-solid fa-circle-check"></i>${text}</li>`).join('');
  }

  function renderStatisticsPage() {
    populateStatsSeasonFilter();
    const myPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    const activeSeasonId = Object.keys(seasons).find(id => seasons[id].isActive) || null;

    const seasonMatchesTraining = (t) => {
      if (statsSeasonFilter === 'all') return true;
      if (statsSeasonFilter === 'active') return activeSeasonId && t.seasonId === activeSeasonId;
      return t.seasonId === statsSeasonFilter;
    };
    const fromMs = statsRangeFrom ? new Date(statsRangeFrom).getTime() : null;
    const toMs = statsRangeTo ? new Date(statsRangeTo + 'T23:59:59').getTime() : null;
    const trainingIds = Object.keys(trainings).filter(id => {
      const t = trainings[id];
      if (!seasonMatchesTraining(t)) return false;
      const ms = t.releaseAtMs || 0;
      if (fromMs != null && ms < fromMs) return false;
      if (toMs != null && ms > toMs) return false;
      return true;
    });

    renderStatsSummaryCards(myPigeons, trainingIds);
    renderStatsTrainingPerformance(trainingIds);
    renderStatsFeedingUsage();
    renderStatsPigeonStatus(myPigeons);
    renderStatsBreedingOverview();
    renderStatsTopPerforming(myPigeons);
    renderStatsRecentTrainings();
    renderStatsTrackerStats();
    renderStatsGroupSummary();
    renderStatsDistanceSummary(activeSeasonId);
    renderStatsQuickInsights(myPigeons);
  }

  setupDismissableBanners(['stats-info-banner'], 'stats-banner-restore-btn', 'fpl-stats-banners-dismissed');
  (function statsDefaultThisMonthRange() {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    statsRangeFrom = start.toISOString().slice(0, 10);
    statsRangeTo = end.toISOString().slice(0, 10);
    statsUpdateRangeLabel();
  })();
  const statsTopperfViewAll = document.getElementById('stats-topperf-viewall');
  if (statsTopperfViewAll) statsTopperfViewAll.onclick = () => activateTab('trainings');
  const statsRecentViewAll = document.getElementById('stats-recent-viewall');
  if (statsRecentViewAll) statsRecentViewAll.onclick = () => activateTab('trainings');
  const statsBreedingViewAll = document.getElementById('stats-breeding-viewall');
  if (statsBreedingViewAll) statsBreedingViewAll.onclick = () => activateTab('pairs');
  const statsTrackerViewAll = document.getElementById('stats-tracker-viewall');
  if (statsTrackerViewAll) statsTrackerViewAll.onclick = () => activateTab('trackers');
  const statsGroupViewAll = document.getElementById('stats-group-viewall');
  if (statsGroupViewAll) statsGroupViewAll.onclick = () => activateTab('group-tracking');
  const statsSeasonFilterEl = document.getElementById('stats-season-filter');
  if (statsSeasonFilterEl) statsSeasonFilterEl.onchange = (e) => { statsSeasonFilter = e.target.value; renderStatisticsPage(); };
  (function wireStatsRangePopover() {
    const rangeWrap = document.getElementById('stats-range');
    const rangeBtn = document.getElementById('stats-range-btn');
    const rangePop = document.getElementById('stats-range-pop');
    if (!rangeBtn || !rangePop) return;
    rangeBtn.onclick = (e) => {
      e.stopPropagation();
      document.getElementById('stats-range-from').value = statsRangeFrom;
      document.getElementById('stats-range-to').value = statsRangeTo;
      rangePop.classList.toggle('open');
    };
    rangePop.onclick = (e) => e.stopPropagation();
    document.getElementById('stats-range-apply').onclick = () => {
      statsRangeFrom = document.getElementById('stats-range-from').value;
      statsRangeTo = document.getElementById('stats-range-to').value;
      if (statsRangeFrom && statsRangeTo && statsRangeTo < statsRangeFrom) {
        const tmp = statsRangeFrom; statsRangeFrom = statsRangeTo; statsRangeTo = tmp;
      }
      rangePop.classList.remove('open');
      statsUpdateRangeLabel();
      renderStatisticsPage();
    };
    document.getElementById('stats-range-clear').onclick = () => {
      statsRangeFrom = ''; statsRangeTo = '';
      rangePop.classList.remove('open');
      statsUpdateRangeLabel();
      renderStatisticsPage();
    };
    document.addEventListener('click', (e) => { if (rangeWrap && !rangeWrap.contains(e.target)) rangePop.classList.remove('open'); });
  })();

  // ---- HOME: the default landing tab. A greeting banner plus 4 quick
  // stats and two recent-activity lists, all computed from data already
  // loaded elsewhere (no collection of its own, same as Statistics).
  function renderHomeTab() {
    // Hero banner: live date/time (ticks on its own timer) + loft location and its current
    // weather (Open-Meteo, keyed off Settings -> Loft's saved coordinates -- never the
    // visitor's own browser/IP location, since what matters here is the weather where the
    // birds actually are). Replaces the old personalised "Welcome Back, Name!" greeting.
    startHomeLiveClock();
    renderHomeLiveWeather();

    const myPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    const totalPairs = Object.keys(breedingPairs).length;
    const trainingIds = Object.keys(trainings);
    const feedingIds = Object.keys(feedings);
    const hasActiveSeason = !!activeSeasonId();

    const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
    const todayFeedingCount = feedingIds.filter(id => feedings[id].fedAtMs >= todayStart.getTime()).length;

    document.getElementById('home-stat-pigeons').textContent = (isAdmin ? allPigeonDocs : myPigeons).length; // admin: every account, like the sidebar
    document.getElementById('home-stat-pairs').textContent = totalPairs;
    document.getElementById('home-stat-season').textContent = hasActiveSeason ? 1 : 0;
    document.getElementById('home-stat-trainings').textContent = trainingIds.length;
    document.getElementById('home-stat-feeding').textContent = todayFeedingCount;
    // Every tracker on the list (same list as the sidebar count) -- status
    // (Active/Calm) is NOT a filter here; removed ones are already gone.
    const homeTrackerIds = isAdmin ? Object.keys(registry) : Object.keys(myTrackerMemberships);
    document.getElementById('home-stat-trackers').textContent =
      homeTrackerIds.length;

    renderHomeActivities(myPigeons);
    renderHomeOverview(myPigeons);
    renderHomeEvents();
  }

  // ---- Hero live info: date + time (no network, just the clock) and loft weather (Open-Meteo,
  // free/keyless, called with the loft's own saved lat/lng -- see renderHomeLiveWeather).
  function renderHomeLiveClock() {
    const dateEl = document.getElementById('home-hero-date');
    const timeEl = document.getElementById('home-hero-time');
    if (!dateEl || !timeEl) return;
    // Once the loft's weather has resolved we know its IANA timezone (Open-Meteo returns it in
    // the same call, see homeWeatherCache.timezone below) -- show the clock in THAT zone, not
    // the viewer's own device time, so the date/time on screen always matches the weather next
    // to it (the loft's local time, not wherever the person checking the dashboard happens to
    // be). Falls back to the viewer's own local time until that first resolves, or if there's
    // no loft/the weather call failed.
    const tz = homeWeatherCache && homeWeatherCache.timezone;
    const now = new Date();
    const dateOpts = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
    const timeOpts = { hour: 'numeric', minute: '2-digit', hour12: true };
    if (tz) { dateOpts.timeZone = tz; timeOpts.timeZone = tz; }
    dateEl.textContent = now.toLocaleDateString('en-GB', dateOpts);
    timeEl.textContent = now.toLocaleTimeString('en-US', timeOpts);
  }
  let homeLiveClockTimer = null;
  function startHomeLiveClock() {
    renderHomeLiveClock();
    if (homeLiveClockTimer) return; // only one ticking interval no matter how often Home re-renders
    homeLiveClockTimer = setInterval(renderHomeLiveClock, 15000);
  }

  // WMO weather codes (what Open-Meteo's weather_code returns) grouped into the handful of
  // icon/label pairs actually shown in the hero -- not every code needs its own entry.
  function homeWeatherInfo(code) {
    const groups = [
      { codes: [0], icon: 'fa-sun', label: 'Clear Sky' },
      { codes: [1, 2], icon: 'fa-cloud-sun', label: 'Partly Cloudy' },
      { codes: [3], icon: 'fa-cloud', label: 'Overcast' },
      { codes: [45, 48], icon: 'fa-smog', label: 'Fog' },
      { codes: [51, 53, 55, 56, 57], icon: 'fa-cloud-rain', label: 'Drizzle' },
      { codes: [61, 63, 65, 66, 67, 80, 81, 82], icon: 'fa-cloud-showers-heavy', label: 'Rain' },
      { codes: [71, 73, 75, 77, 85, 86], icon: 'fa-snowflake', label: 'Snow' },
      { codes: [95, 96, 99], icon: 'fa-bolt', label: 'Thunderstorm' },
    ];
    return groups.find(g => g.codes.includes(code)) || { icon: 'fa-cloud', label: 'Weather' };
  }

  // Saved per loft point (rounded to ~100m) so Home re-rendering on every Firestore snapshot
  // change doesn't re-hit Open-Meteo every time -- only once per loft point per 15 minutes.
  let homeWeatherCache = null; // { key, fetchedAt, temp, code, rainPct }
  const HOME_WEATHER_TTL_MS = 15 * 60 * 1000;
  async function renderHomeLiveWeather() {
    const locEl = document.getElementById('home-hero-loc');
    const wxEl = document.getElementById('home-hero-wx');
    if (!locEl || !wxEl) return;
    const loft = currentOrg && currentOrg.homeLoft;
    if (!loft || typeof loft.lat !== 'number' || typeof loft.lng !== 'number') {
      // No loft saved -- a friendly nudge instead of falling back to the visitor's own
      // browser/IP location, which would describe the wrong place for a pigeon loft.
      locEl.innerHTML = '<i class="fa-solid fa-location-dot"></i> <a href="#" id="home-hero-loft-link">Set your loft location</a> to see local weather here';
      const link = document.getElementById('home-hero-loft-link');
      if (link) link.onclick = (e) => { e.preventDefault(); goToLoftSettings(); };
      wxEl.style.display = 'none';
      homeWeatherCache = null; // no loft -- the clock falls back to the viewer's own local time
      renderHomeLiveClock();
      return;
    }
    const placeName = [loft.city, loft.country].filter(Boolean).join(', ') || (loft.lat.toFixed(2) + ', ' + loft.lng.toFixed(2));
    locEl.innerHTML = '<i class="fa-solid fa-location-dot"></i> ' + admEsc(placeName);

    const key = loft.lat.toFixed(3) + ',' + loft.lng.toFixed(3);
    const fresh = homeWeatherCache && homeWeatherCache.key === key && (Date.now() - homeWeatherCache.fetchedAt) < HOME_WEATHER_TTL_MS;
    if (!fresh) {
      try {
        const url = 'https://api.open-meteo.com/v1/forecast?latitude=' + loft.lat + '&longitude=' + loft.lng +
          '&current=temperature_2m,weather_code&hourly=precipitation_probability&forecast_days=1&timezone=auto';
        const data = await fetch(url).then(r => r.json());
        const current = data.current || {};
        const hourKey = (current.time || '').slice(0, 13); // "YYYY-MM-DDTHH"
        const hourlyTimes = (data.hourly && data.hourly.time) || [];
        let idx = hourlyTimes.findIndex(t => t.slice(0, 13) === hourKey);
        if (idx < 0) idx = 0;
        const rainArr = data.hourly && data.hourly.precipitation_probability;
        homeWeatherCache = {
          key, fetchedAt: Date.now(),
          temp: typeof current.temperature_2m === 'number' ? Math.round(current.temperature_2m) : null,
          code: current.weather_code,
          rainPct: rainArr ? rainArr[idx] : null,
          timezone: data.timezone || null, // e.g. "Asia/Kolkata" -- also drives the hero clock, see renderHomeLiveClock
        };
      } catch (e) {
        // Open-Meteo hiccup: a same-loft cache is still roughly right, so leave it in place --
        // but never show a DIFFERENT loft's now-stale weather/timezone, which would be actively
        // wrong rather than just old (and would leave the clock quietly stuck on the wrong
        // place's time). Clear it so the clock falls back to the viewer's own local time.
        if (!homeWeatherCache || homeWeatherCache.key !== key) homeWeatherCache = null;
      }
    }
    renderHomeLiveClock(); // the timezone may have just changed (new loft, or the first successful fetch)
    if (!homeWeatherCache || homeWeatherCache.key !== key || homeWeatherCache.temp === null) { wxEl.style.display = 'none'; return; }
    const info = homeWeatherInfo(homeWeatherCache.code);
    const hasRain = typeof homeWeatherCache.rainPct === 'number' && homeWeatherCache.rainPct > 0;
    // Two versions of the condition/rain text -- the full words (desktop, unchanged) and an
    // icon-only short form (mobile only, see the .home-hero-wx-label/-rain-full/-rain-short
    // CSS toggles in the phone media query) -- so only the mobile hero gets the compact look.
    const rainFull = hasRain ? ' <span class="home-hero-dot">&middot;</span> ' + homeWeatherCache.rainPct + '% chance of rain' : '';
    const rainShort = hasRain ? ' <span class="home-hero-dot home-hero-rain-short">&middot;</span><span class="home-hero-rain-short"><i class="fa-solid fa-droplet"></i> ' + homeWeatherCache.rainPct + '%</span>' : '';
    wxEl.innerHTML = '<span class="home-hero-dot">&middot;</span> <i class="fa-solid ' + info.icon + '"></i> ' + homeWeatherCache.temp + '&deg;C' +
      '<span class="home-hero-wx-label"> &middot; ' + info.label + rainFull + '</span>' + rainShort;
    wxEl.style.display = '';
  }

  function tsMs(x) {
    return x && x.toMillis ? x.toMillis() : 0;
  }

  // Unified activity feed -- merges pigeons/trainings/feedings/breeding
  // pairs/seasons (each already loaded for their own tab) into one
  // timeline sorted by createdAt, matching the reference "Recent
  // Activities" table. "Added By" is always this org's own name since
  // there's no multi-user/team concept on an account.
  const HOME_ACTIVITIES_PER_PAGE = 6;
  let homeActivityRows = [];
  let homeActivitiesPage = 1;

  function renderHomeActivities(myPigeons) {
    const tbody = document.getElementById('home-activities-body');
    if (!tbody) return;
    const addedBy = (document.getElementById('db-avatar-name') || {}).textContent || 'You';
    const rows = [];

    myPigeons.forEach(d => {
      rows.push({
        ts: tsMs(d.p.createdAt), type: 'Pigeon', icon: 'fa-dove', bg: '#e3effd', fg: '#2f6fed',
        details: 'New pigeon added' + (d.p.ringNumber ? ' (' + d.p.ringNumber + ')' : ''), related: 'Pigeon List'
      });
    });
    trainingIdsList().forEach(id => {
      const t = trainings[id];
      rows.push({
        ts: tsMs(t.createdAt), type: 'Training', icon: 'fa-flag-checkered', bg: '#f1eafd', fg: '#7b3fe4',
        details: (t.distanceKm || 0) + ' km - ' + (t.releasePoint || 'Training'), related: t.seasonId && seasons[t.seasonId] ? seasons[t.seasonId].name : 'Trainings'
      });
    });
    Object.keys(feedings).forEach(id => {
      const f = feedings[id];
      rows.push({
        ts: tsMs(f.createdAt), type: 'Feeding', icon: 'fa-bowl-food', bg: '#fdecd8', fg: '#f4a623',
        details: (f.quantity != null ? f.quantity + ' ' + (f.unit || 'kg') + ' ' : '') + (f.feedType || 'Feed'), related: f.loftGroup || 'All Pigeons'
      });
    });
    Object.keys(breedingPairs).forEach(id => {
      const bp = breedingPairs[id];
      const cock = findPigeonDoc(bp.cockId);
      const hen = findPigeonDoc(bp.henId);
      rows.push({
        ts: tsMs(bp.createdAt), type: 'Breeding', icon: 'fa-heart', bg: '#fdeef0', fg: '#e5537e',
        details: 'Paired ' + (cock ? cock.p.name : 'Unknown') + ' x ' + (hen ? hen.p.name : 'Unknown'), related: 'Breeding Pairs'
      });
    });
    Object.keys(seasons).forEach(id => {
      const s = seasons[id];
      rows.push({
        ts: tsMs(s.createdAt), type: 'Season', icon: 'fa-calendar-days', bg: '#e3f6e8', fg: '#19a974',
        details: 'Season ' + (s.name || s.year || '') + ' started', related: s.name || 'Seasons'
      });
    });

    rows.sort((a, b) => b.ts - a.ts);
    homeActivityRows = rows.map(r => Object.assign({ addedBy }, r));
    drawHomeActivitiesPage();
  }

  // Draws the current page of the (already sorted) activity list, 6 rows
  // per page. On a short last page the leftover slots are filled with
  // blank rows of the same fixed height, so the card doesn't shrink/jump
  // when paging. The pager only appears when there's more than one page.
  function drawHomeActivitiesPage() {
    const tbody = document.getElementById('home-activities-body');
    const pager = document.getElementById('home-activities-pagination');
    if (!tbody) return;
    const total = homeActivityRows.length;
    if (total === 0) {
      tbody.innerHTML = '<tr><td colspan="5" class="home-activities-empty">No activity yet -- add a pigeon, log a training, or record a feeding to see it here.</td></tr>';
      if (pager) { pager.style.display = 'none'; pager.innerHTML = ''; }
      return;
    }
    const totalPages = Math.ceil(total / HOME_ACTIVITIES_PER_PAGE);
    if (homeActivitiesPage > totalPages) homeActivitiesPage = totalPages;
    if (homeActivitiesPage < 1) homeActivitiesPage = 1;
    const start = (homeActivitiesPage - 1) * HOME_ACTIVITIES_PER_PAGE;
    const pageRows = homeActivityRows.slice(start, start + HOME_ACTIVITIES_PER_PAGE);
    let html = pageRows.map(r => {
      const dateStr = r.ts ? fmtDateShort(r.ts) : '—';
      return '<tr>' +
        '<td>' + dateStr + '</td>' +
        '<td><span class="home-activities-icon" style="background:' + r.bg + ';color:' + r.fg + ';"><i class="fa-solid ' + r.icon + '"></i></span><span class="home-act-type-text">' + r.type + '</span></td>' +
        '<td><div class="home-act-clip">' + r.details + '</div></td>' +
        '<td><div class="home-act-clip">' + r.related + '</div></td>' +
        '<td>' + r.addedBy + '</td>' +
      '</tr>';
    }).join('');
    if (totalPages > 1) {
      for (let i = pageRows.length; i < HOME_ACTIVITIES_PER_PAGE; i++) {
        html += '<tr class="home-act-filler"><td colspan="5"></td></tr>';
      }
    }
    tbody.innerHTML = html;
    if (!pager) return;
    if (totalPages <= 1) { pager.style.display = 'none'; pager.innerHTML = ''; return; }

    // 1 ... (p-1) p (p+1) ... N -- every page number when there are only a few.
    const pages = [];
    for (let p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || Math.abs(p - homeActivitiesPage) <= 1) pages.push(p);
      else if (pages[pages.length - 1] !== '…') pages.push('…');
    }
    let pagerHtml = '<button type="button" class="home-page-btn" data-page="' + (homeActivitiesPage - 1) + '"' + (homeActivitiesPage === 1 ? ' disabled' : '') + '>&larr; Prev</button>';
    pages.forEach(p => {
      pagerHtml += p === '…'
        ? '<span class="home-page-gap">…</span>'
        : '<button type="button" class="home-page-btn' + (p === homeActivitiesPage ? ' active' : '') + '" data-page="' + p + '">' + p + '</button>';
    });
    pagerHtml += '<button type="button" class="home-page-btn" data-page="' + (homeActivitiesPage + 1) + '"' + (homeActivitiesPage === totalPages ? ' disabled' : '') + '>Next &rarr;</button>';
    pager.innerHTML = pagerHtml;
    pager.style.display = 'flex';
  }
  function trainingIdsList() { return Object.keys(trainings); }

  // Pigeon Overview -- a simple CSS bar chart (no charting library loaded)
  // showing cumulative pigeon count over the last 6 months, plus a legend
  // of best-effort status counts computed from data we already track.
  // These are independent facts, not a strict partition of the total (a
  // bird can be both "In Training" and "Breeding" at once), same as the
  // reference design's own categories.
  function renderHomeOverview(myPigeons) {
    const chartEl = document.getElementById('home-overview-chart');
    const legendEl = document.getElementById('home-overview-legend');
    if (!chartEl || !legendEl) return;

    const months = [];
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthEndMs = new Date(d.getFullYear(), d.getMonth() + 1, 1).getTime() - 1;
      const count = myPigeons.filter(p => tsMs(p.p.createdAt) && tsMs(p.p.createdAt) <= monthEndMs).length;
      months.push({ label: d.toLocaleDateString('en-GB', { month: 'short' }), count });
    }
    const maxCount = Math.max(1, ...months.map(m => m.count));
    chartEl.innerHTML = months.map(m => {
      const heightPct = Math.max(8, Math.round((m.count / maxCount) * 100));
      return '<div class="home-overview-chart-col"><div class="home-overview-chart-bar" style="height:' + heightPct + '%;" title="' + m.count + '"></div><div class="home-overview-chart-label">' + m.label + '</div></div>';
    }).join('');

    const activeCount = myPigeons.filter(d => !d.p.isArchived).length;
    const inactiveCount = myPigeons.length - activeCount;
    const trainingPigeonIds = new Set();
    Object.values(trainings).forEach(t => (t.participatingPigeonIds || []).forEach(id => trainingPigeonIds.add(id)));
    const inTrainingCount = myPigeons.filter(d => trainingPigeonIds.has(d.id)).length;
    const breedingPigeonIds = new Set();
    Object.values(breedingPairs).forEach(bp => { if (bp.cockId) breedingPigeonIds.add(bp.cockId); if (bp.henId) breedingPigeonIds.add(bp.henId); });
    const breedingCount = myPigeons.filter(d => breedingPigeonIds.has(d.id)).length;
    const oneYearAgoMs = Date.now() - 365 * 24 * 60 * 60 * 1000;
    const youngBirdCount = myPigeons.filter(d => d.p.dateOfBirth && new Date(d.p.dateOfBirth).getTime() >= oneYearAgoMs).length;

    const legendRows = [
      { label: 'Total Pigeons', num: myPigeons.length, color: 'var(--primary)' },
      { label: 'Active', num: activeCount, color: 'var(--primary)' },
      { label: 'In Training', num: inTrainingCount, color: 'var(--success)' },
      { label: 'Breeding', num: breedingCount, color: '#e5537e' },
      { label: 'Young Birds', num: youngBirdCount, color: 'var(--warning)' },
      { label: 'Inactive', num: inactiveCount, color: 'var(--text-secondary)' }
    ];
    legendEl.innerHTML = legendRows.map(r =>
      '<div class="home-overview-legend-row"><span class="home-overview-legend-dot" style="background:' + r.color + ';"></span>' + r.label + '<span class="home-overview-legend-num">' + r.num + '</span></div>'
    ).join('');
  }

  // Upcoming Events -- a small new "events" collection (title, date,
  // related info), since nothing else in the app tracks future-dated
  // items (Trainings explicitly blocks a future release date/time). Only
  // the display is built here; there's no Add Event UI yet since that
  // wasn't part of what was asked for -- this shows real data once any
  // exists, an honest empty state until then.
  let events = {};
  function listenForEvents() {
    const query = isAdmin ? db.collection('events') : db.collection('events').where('ownerUid', '==', auth.currentUser.uid);
    query.onSnapshot(snapshot => {
      events = {};
      snapshot.forEach(doc => { events[doc.id] = doc.data(); });
      if (document.getElementById('db-panel-home').classList.contains('active')) renderHomeEvents();
    }, error => console.error('Events listener error:', error));
  }
  function renderHomeEvents() {
    const el = document.getElementById('home-events-list');
    if (!el) return;
    const nowMs = Date.now();
    const upcoming = Object.keys(events)
      .filter(id => events[id].eventDate >= nowMs)
      .sort((a, b) => events[a].eventDate - events[b].eventDate)
      .slice(0, 4);
    if (upcoming.length === 0) {
      el.innerHTML = '<div class="home-events-empty">No upcoming events yet.</div>';
      return;
    }
    el.innerHTML = upcoming.map(id => {
      const e = events[id];
      const d = new Date(e.eventDate);
      return '<div class="home-event-row">' +
        '<div class="home-event-date"><span class="day">' + d.getDate() + '</span><span class="mon">' + d.toLocaleDateString('en-GB', { month: 'short' }).toUpperCase() + '</span></div>' +
        '<div class="home-event-main"><b>' + (e.title || 'Event') + '</b><span>' + (e.relatedInfo || '') + '</span></div>' +
        '<div class="home-event-badge">Upcoming</div>' +
      '</div>';
    }).join('');
  }

  // Quick Actions -- jump straight into the same Add modals used on their
  // own tabs, without navigating away from Home first.
  const homeQaMap = {
    'home-qa-pigeon': () => openAddModal(),
    'home-qa-pair': () => openNewPairModal(),
    'home-qa-training': () => openAddTrainingModal(),
    'home-qa-feeding': () => openAddFeedingModal(),
    'home-qa-season': () => openNewSeasonModal(),
    'home-qa-tracker': () => openAddTrackerModal()
  };
  Object.keys(homeQaMap).forEach(id => {
    const el = document.getElementById(id);
    if (el) el.onclick = homeQaMap[id];
  });

  // Stat cards and "view all" links just jump to the matching tab -- wired
  // once here since none of it depends on data, unlike the numbers/lists
  // renderHomeTab fills in on every re-render.
  document.querySelectorAll('.home-stat-link, .home-view-all-link').forEach(el => {
    el.onclick = () => activateTab(el.dataset.tab);
  });
  document.getElementById('home-stat-card-trackers').onclick = (e) => {
    if (!e.target.closest('.home-stat-link')) activateTab('trackers');
  };

  // Recent Activities pager -- one delegated handler; the buttons themselves
  // are re-rendered on every page change (see drawHomeActivitiesPage).
  const homePager = document.getElementById('home-activities-pagination');
  if (homePager) {
    homePager.addEventListener('click', e => {
      const btn = e.target.closest('.home-page-btn');
      if (!btn || btn.disabled) return;
      homeActivitiesPage = parseInt(btn.dataset.page, 10) || 1;
      drawHomeActivitiesPage();
    });
  }

